import SettingTypes from '@/utils/setting-types'

export default {
  name: 'image-text-adv',
  label: {
    title: '图文广告',
    icon: require('@/assets/icon-component-label_ImageAdv.png'),
    limit: 300
  },
  sort: 3,
  data: {
    // 标题
    title: '标题',
    // 标题字体大小
    title_font_size: 36,
    // 标题字体粗细
    title_font_weight: 'bold',
    // 标题颜色
    title_color: '#323233',
    // 副标题
    sub_title: '副标题',
    // 副标题字体大小
    sub_title_font_size: 24,
    // 副标题字体粗细
    sub_title_font_weight: '400',
    // 副标题颜色
    sub_title_color: '#969799',
    // 页面背景样式显示
    show_background_style: false,
    // 页面背景样式
    background_style: 'color',
    // 背景图片
    background_image: '',
    // 背景颜色
    background_color: '#ffffff',
    // 显示更多
    show_more: false,
    // 查看更多样式【1、2、3】
    more_style: 1,
    // 查看更多文字
    more_text: '查看更多',
    // 查看更多链接
    more_link: '',
    // 查看更多颜色
    more_color: '#969799',
    // 内容类型
    content_type: 'image',
    // 图片列表
    imageList: [],
    // 页面边距
    page_edge: 20,
    // 页面圆角
    page_radius: 20,
    // 商品列表
    goodsList: [],
    // 列表样式
    list_style: 'vertical',
    // 商品间距
    goods_space: 20,
    // 图片比例
    image_ratio: '3:2',
    // 图片填充
    image_fill: 'cover',
    // 显示商品名称
    show_goods_name: true,
    // 显示商品规格
    show_goods_specs: true,
    // 显示商品价格
    show_goods_price: true,
    // 显示商品原价
    show_goods_original_price: true,
    // 显示商品购买按钮
    show_goods_buy_btn: true,
    // 购买按钮样式
    goods_buy_btn_style: 1,
    // 购买按钮文字
    goods_buy_btn_text: '',
    // 显示商品角标
    show_goods_badge: false,
    // 商品角标类型
    goods_badge_style: 'new',
    // 自定义商品角标图片
    goods_badge_style_image: '',
    // 自定义商品购买按钮图片
    buy_btn_style_image: ''
  },
  settings: {
    title: {
      type: SettingTypes.input,
      label: '标题'
    },
    sub_title: {
      type: SettingTypes.input,
      label: '副标题',
      space_line: true
    },
    title_font_size: {
      type: SettingTypes.radio_button,
      label: '标题大小',
      options: [
        { label: '大（18号）', value: 36, icon: 'rb-icon-font-x' },
        { label: '中（16号）', value: 32, icon: 'rb-icon-font-m' },
        { label: '小（14号）', value: 28, icon: 'rb-icon-font-s' }
      ]
    },
    sub_title_font_size: {
      type: SettingTypes.radio_button,
      label: '副标题大小',
      options: [
        { label: '大（16号）', value: 32, icon: 'rb-icon-font-x' },
        { label: '中（14号）', value: 28, icon: 'rb-icon-font-m' },
        { label: '小（12号）', value: 24, icon: 'rb-icon-font-s' }
      ]
    },
    title_font_weight: {
      type: SettingTypes.radio_button,
      label: '标题粗细',
      options: [
        { label: '常规体', value: '400', icon: 'rb-icon-font-regular' },
        { label: '加粗体', value: 'bold', icon: 'rb-icon-font-bold' }
      ]
    },
    sub_title_font_weight: {
      type: SettingTypes.radio_button,
      label: '副标题粗细',
      options: [
        { label: '常规体', value: '400', icon: 'rb-icon-font-regular' },
        { label: '加粗体', value: 'bold', icon: 'rb-icon-font-bold' }
      ]
    },
    title_color: {
      type: SettingTypes.color_picker,
      label: '标题颜色',
      default: '#323233'
    },
    sub_title_color: {
      type: SettingTypes.color_picker,
      label: '副标题颜色',
      default: '#969799'
    },
    page_edge: {
      type: SettingTypes.slider,
      label: '页面边距',
      props: {
        min: 0,
        max: 200
      }
    },
    page_radius: {
      type: SettingTypes.slider,
      label: '页面圆角',
      props: {
        min: 0,
        max: 750
      }
    },
    show_more: {
      type: SettingTypes.boolean,
      label: '查看更多',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      option: {
        key: 'more_style',
        type: 'radio',
        options: [
          { label: '样式一', value: 1 },
          { label: '样式二', value: 2 },
          { label: '样式三', value: 3 }
        ],
        custom_component_name: 'TitleTextMoreStyle'
      }
    },
    more_color: {
      type: SettingTypes.color_picker,
      label: '查看更多颜色',
      default: '#969799'
    },
    show_background_style: {
      type: SettingTypes.boolean,
      label: '背景样式',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      option: {
        key: 'background_style',
        options: [
          { label: '颜色', value: 'color' },
          { label: '图片', value: 'image' }
        ],
        custom_component_name: 'backgroundImageStyle'
      },
      space_line: true
    },
    content_type: {
      type: SettingTypes.radio_button,
      label: '内容类型',
      options: [
        { label: '图片', value: 'image' },
        { label: '商品', value: 'goods' }
      ]
    },
    image_list: {
      type: SettingTypes.custom,
      component_name: 'ImageTextAdvSelector',
      space_line: true,
      show: data => data.content_type === 'image'
    },
    list_style: {
      type: SettingTypes.radio_button,
      label: '列表样式',
      options: [
        { label: '竖向', value: 'vertical' },
        { label: '横向', value: 'horizontal' }
      ],
      show: data => data.content_type === 'goods'
    },
    goodsList: {
      type: SettingTypes.custom,
      component_name: 'GoodsSettingSelector',
      space_line: true,
      show: data => data.content_type === 'goods'
    },
    goods_space: {
      type: SettingTypes.slider,
      label: '商品间距',
      props: {
        min: 0,
        max: 60
      },
      show: data => data.content_type === 'goods'
    },
    image_ratio: {
      type: SettingTypes.select,
      label: '图片比例',
      options: [
        { label: '3:2', value: '3:2' },
        { label: '1:1', value: '1:1' },
        { label: '3:4', value: '3:4' },
        { label: '16:9', value: '16:9' },
        { label: '1.9:1', value: '1.9:1' }
      ],
      show: data => data.content_type === 'goods'
    },
    image_fill: {
      type: SettingTypes.radio_button,
      label: '图片填充',
      options: [
        { label: '填充', value: 'cover', icon: 'rb-icon-img-cover' },
        { label: '周边留白', value: 'contain', icon: 'rb-icon-img-contain' }
      ],
      show: data => data.content_type === 'goods'
    },
    show_goods_name: {
      type: SettingTypes.boolean,
      label: '商品名称',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      show: data => data.content_type === 'goods'
    },
    show_goods_specs: {
      type: SettingTypes.boolean,
      label: '商品规格',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      show: data => data.content_type === 'goods'
    },
    show_goods_price: {
      type: SettingTypes.boolean,
      label: '商品价格',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      show: data => data.content_type === 'goods'
    },
    show_goods_original_price: {
      type: SettingTypes.boolean,
      label: '商品原价',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      show: data => data.content_type === 'goods'
    },
    show_goods_buy_btn: {
      type: SettingTypes.boolean,
      label: '购买按钮',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      option: {
        type: 'radio',
        key: 'goods_buy_btn_style',
        options: [
          { label: '样式1', value: 1 },
          { label: '样式2', value: 2 },
          { label: '样式5', value: 5 },
          { label: '样式6', value: 6 },
          { label: '自定义', value: 10 }
        ],
        custom_component_name: 'GoodsSettingCustomBuyBtn'
      },
      show: data => data.content_type === 'goods'
    },
    show_goods_badge: {
      type: SettingTypes.boolean,
      label: '商品角标',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      option: {
        key: 'goods_badge_style',
        type: 'radio',
        options: [
          { label: '新品', value: 'new' },
          { label: '热卖', value: 'hot' },
          { label: 'NEW', value: 'NEW' },
          { label: 'HOT', value: 'HOT' },
          { label: '自定义', value: '' }
        ],
        custom_component_name: 'GoodsSettingCustomBadgeStyle'
      },
      show: data => data.content_type === 'goods'
    }
  }
}
